import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';

function ModalPatrimoniais(props) {
  const { patrimoniais, setPatrimoniais, anos, meses, setSelected, openPatrimonial, fileToFind, setFileToFind } = props;

  const [showHistorico, setShowHistorico] = useState(false);

  useEffect(() => {
    setShowHistorico(false);
    setFileToFind({
      mesSelecionado: undefined,
      anoSelecionado: undefined,
    });
  }, [patrimoniais.patrimoniais]);

  return (
    <Modal
      show={patrimoniais.patrimoniais}
      onHide={() =>
        setPatrimoniais({
          ...patrimoniais,
          patrimoniais: !patrimoniais.patrimoniais,
        })
      }
    >
      <Modal.Header>
        <Modal.Title>Escolha a patrimonial a consultar!</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <Select
              name="patrimonialSelect"
              options={patrimoniais.patrimoniaisList}
              closeMenuOnSelect
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Escolha a patrimonial..."
              onChange={setSelected}
            />
          </Col>
        </Row>

        <div style={{ marginBottom: '1rem' }}>
          <Button variant="link" onClick={() => setShowHistorico(!showHistorico)}>
            Consultar histórico
          </Button>
        </div>

        {showHistorico && (
          <Row className="gy-3">
            <Col>
              <Select
                name="ano"
                options={anos?.reduce((acc, cv) => [...acc, { label: cv, value: cv }], []) || []}
                closeMenuOnSelect
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Escolha o Ano..."
                isClearable
                onChange={(e) =>
                  setFileToFind({
                    ...fileToFind,
                    anoSelecionado: e,
                  })
                }
              />
            </Col>
            <Col>
              <Select
                name="mes"
                options={meses?.reduce((acc, cv) => [...acc, { label: cv, value: cv }], []) || []}
                closeMenuOnSelect
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Escolha o Mês..."
                isClearable
                onChange={(e) =>
                  setFileToFind({
                    ...fileToFind,
                    mesSelecionado: e,
                  })
                }
              />
            </Col>
          </Row>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            size="sm"
            onClick={() =>
              setPatrimoniais({
                ...patrimoniais,
                patrimoniais: !patrimoniais.patrimoniais,
              })
            }
            variant="outline-danger"
            style={{ marginRight: '10px' }}
            type="button"
          >
            Fechar
          </Button>
          <Button size="sm" variant="primary" onClick={openPatrimonial}>
            Consultar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalPatrimoniais;
